<script lang="ts" setup>
import useBackupExport from './useBackupExport';

const { prepareBackup } = useBackupExport();

function exportBundles() {
  const backup = prepareBackup();
  const filename = `bundle-${new Date().toISOString()}`;
  downloadGeneratedJson(backup, filename);
}

function downloadGeneratedJson(data: object, filename: string): void {
  const jsonData = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
</script>

<template>
  <v-btn @click="exportBundles">
    <v-icon>mdi-file-export</v-icon>
    <span class="ml-2">Export</span>
  </v-btn>
</template>
